export const StructureAnswersForSelectables = (AnswerList, Type) => {
  const StructuredData = AnswerList.map((answer) =>
    Type === "RadCheckedDropDownList"
      ? {
          ItemValue: answer.Id,
          ItemContent: answer.Name,
        }
      : {
          label: answer.name ?? answer.Name,
          id: answer.id ?? answer.Id,
        }
  );

  return StructuredData;
};
